import Timeline from '@mui/lab/Timeline'
import { useTranslation } from 'react-i18next'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
// import { data } from '../../RacesData/data'
import dayjs from 'dayjs'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'

export default function TimelineView ({ data = [], isEvent /*, isRace */ }) {
  const { t } = useTranslation('races')
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))
  const today = dayjs()

  // First, sort the data by date in descending order (newest first)
  const sortedData = [...data].sort((a, b) => dayjs(b.date[0]).diff(dayjs(a.date[0])))

  // Then insert the "Today" marker in the correct chronological position
  const timelineData = []
  let todayInserted = false

  // Add "Today" marker at the beginning if there are no events, or insert it in the correct position
  for (let i = 0; i < sortedData.length; i++) {
    const eventDate = dayjs(sortedData[i].date[0])

    // If we haven't inserted "Today" and the current event is today or in the past, insert "Today" before it
    if (!todayInserted && !eventDate.isAfter(today)) {
      timelineData.push({ title: '', date: [today.toDate()] })
      todayInserted = true
    }

    timelineData.push(sortedData[i])
  }

  // If "Today" wasn't inserted yet (all events are in the future), add it at the end
  if (!todayInserted) {
    timelineData.push({ title: '', date: [today.toDate()] })
  }

  return (
    <Box>
      <Timeline position='alternate' sx={{ p: 0 }}>
        {timelineData.map((event, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent
              align='right'
              variant={isXs ? 'subtitle2' : 'h4'}
              sx={{
                color: 'text.secondary',
                m: 'auto 0',
                px: { xs: 0.5, md: 2, lg: 3 }
              }}
            >
              {dayjs(new Date(event.date[0])).format('DD/MMM/YYYY')}
            </TimelineOppositeContent>
            <TimelineSeparator>
              {index > 0 && <TimelineConnector />}
              <TimelineDot
                sx={{
                width: 84,
                height: 84,
                ...(event.slug && { background: 'none', boxShadow: 'none' })
              }}
              >
                {event.slug
                  ? (
                    <img
                      src='https://d1hi0tbu2kom2c.cloudfront.net/img/events/peaks.png' // {`https://d1hi0tbu2kom2c.cloudfront.net/img/${isEvent ? 'events' : 'races'}/i/${event.slug}.jpg`}
                      alt={event.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                    />
                    )
                  : <img
                      src='https://d1hi0tbu2kom2c.cloudfront.net/img/today.jpg'
                      alt={event.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                    />}
              </TimelineDot>
              {index < timelineData.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ minHeight: event.title ? '220px' : 'unset', py: '12px', px: { xs: 0.5, md: 2, lg: 3 } }}>
              <Typography variant='h6' component='span'>
                {event.title}
              </Typography>
              {event.subtitle && <Typography>{event.subtitle}</Typography>}
              {event.title &&
              <Typography
                variant='caption'
                sx={{ display: 'block', fontWeight: 'bold', mb: 2 }}
                color={event.status === 'open' ? 'success.main' : 'warning.main'}
              >
                {event.status === 'open'
                  ? t('status.openForRegistration')
                  : event.status === 'soon'
                    ? t('status.openingSoon')
                    : event.status === 'ended'
                      ? t('status.eventEnded')
                      : t('status.openingLater')
                  }
              </Typography>}
              {event.title !== 'Today' && event.slug && (
              <Box
                sx={{
                display: 'flex',
                justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
                mt: 1
              }}
              >
                {!isEvent &&
                  <Button
                    component={Link}
                    to={event.status === 'open'
                      ? `/races/${event.slug}/registration`
                      : `/races/${event.slug}/details`}
                    variant={event.status === 'open' ? 'contained' : 'outlined'}
                    color='primary'
                    sx={{ minWidth: 120 }}
                  >
                    {event.status === 'open' ? t('actions.registerNow') : t('actions.viewEvent')}
                  </Button>
                }
                {!isEvent &&
                  <Button
                    component={Link}
                    to={event.status === 'open'
                      ? `/races/${event.slug}/registration`
                      : `/races/${event.slug}/details`}
                    variant={event.status === 'open' ? 'contained' : 'outlined'}
                    color='primary'
                    sx={{ minWidth: 120 }}
                  >
                    {event.status === 'open' ? t('actions.registerNow') : t('actions.viewEvent')}
                  </Button>}

                  {isEvent &&
                    <Button
                      component={Link}
                      to={`/events/${event.slug}`}
                      variant={event.status === 'open' ? 'contained' : 'outlined'}
                      color={event.status === 'open' ? 'primary' : 'secondary' }
                      sx={{ minWidth: 120 }}
                      // disabled={event.status !== 'open'}
                    >
                      {event.status === 'open' ? t('actions.viewEvent') : t('status.eventEnded')}
                    </Button>}
              </Box>
              )}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  )
}
